import { registerSW } from 'virtual:pwa-register';

export default function useVitePwa() {
  const init = (): void => {
    const intervalMS = 1000 * 60 * 60;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const updateSW = registerSW({
      onRegisteredSW(swUrl, r) {
        r &&
          setInterval(async () => {
            if (!(!r.installing && navigator)) return;

            if ('connection' in navigator && !navigator.onLine) return;

            const resp = await fetch(swUrl, {
              cache: 'no-store',
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              'cache-control': 'no-cache',
            });

            if (resp?.status === 200) await r.update();
          }, intervalMS);
      },
    });
  };

  return {
    init,
  };
}
